import { render } from "./BookingSubmission.vue?vue&type=template&id=d987a3da"
import script from "./BookingSubmission.vue?vue&type=script&lang=js"
export * from "./BookingSubmission.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__